import Vue from 'vue'

export default {
  // https://www.telerik.com/blogs/so-what-actually-is-vue-set
  UPDATE_PODCAST (state, value) {
      Vue.set(state, 'podcasts', value);
  },
  SET_PODCAST (state, value) {
      this.commit('UPDATE_PODCAST', value);
  },
  SET_SELECTED_PODCAST (state,  value ) {
    Vue.set(state, 'selectedPodcast', value);
  },
  // --------------------------------------------------------
  UPDATE_ADVISORY_BOARD (state, value) {
    Vue.set(state, 'advisoryBoard', value);
  },
  SET_ADVISORY_BOARD (state, value) {
    this.commit('UPDATE_ADVISORY_BOARD', value);
  },
  SET_SELECTED_ADVISORY_BOARD (state,  value ) {
    Vue.set(state, 'selectedAdvisoryBoard', value);
    console.log('[inside mutation.js --> SET_SELECTED_ADVISORY_BOARD] ---> selectedAdvisoryBoard', this.selectedAdvisoryBoard)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/podcasts/mutations.js